import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight, Phone, Mail, MapPin } from "lucide-react";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Helmet } from "react-helmet-async";

gsap.registerPlugin(ScrollTrigger);

export default function PartenairesCategoryPage() {
  const { category } = useParams();

  const cardsRef = useRef([]);
  const heroRef = useRef(null);
  const bgRef = useRef(null);

  const data = {
    supermarches: {
      title: "Supermarchés",
      subtitle:
        "Des enseignes engagées qui soutiennent l’association à travers des collectes, des relais locaux et des actions solidaires.",
      image:
        "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=1600&q=80",
      partners: [
        {
          name: "Médor et Compagnie",
          image:
            "https://static.wixstatic.com/media/456cbd_64bc168788a647fda476e0daf7e5597d~mv2.png/v1/fill/w_316,h_370,al_c,lg_1,q_85,enc_avif,quality_auto/image_edited.png",
          siteWeb:
            "https://www.medoretcie.com/animalerie/medor-et-compagnie-chambery-73000-chr.html?srsltid=AfmBOoq2JTfCsHQsI-fNtDz_1srJYnDkatxKng95WbGTAwiQOISiiguO",
        },
        {
          name: "Carrefour Market",
          image:
            "https://static.wixstatic.com/media/456cbd_1e604860944749b5971c2110ca15da05~mv2.jpg/v1/fill/w_572,h_670,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/383666_carrefour-market.jpg",
          siteWeb: "https://www.carrefour.fr/enseignes/market",
        },
        {
          name: "Hyper U",
          image:
            "https://static.wixstatic.com/media/456cbd_12100f57b89249cb8bc8791ce94eb927~mv2.png/v1/fill/w_427,h_500,al_c,q_85,enc_avif,quality_auto/image.png",
        },
        {
          name: "Cyno-Pro",
          image:
            "https://static.wixstatic.com/media/456cbd_6ed2a382c6cf4728b9938ca4cb0e2879~mv2.png/v1/fill/w_269,h_315,al_c,lg_1,q_85,enc_avif,quality_auto/image.png",
          siteWeb: "https://cyno-pro.com/magasins",
        },
        {
          name: "Gamm Vert",
          image:
            "https://static.wixstatic.com/media/456cbd_c245886e1461465d8c5ee792605c3fc3~mv2.png/v1/fill/w_572,h_670,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/image.png",
          siteWeb: "https://cyno-pro.com/magasins",
        },
        {
          name: "Bricomarché",
          image:
            "https://static.wixstatic.com/media/456cbd_4fb3bf112ffc41bf9e8a16686dc7b28e~mv2.png/v1/fill/w_410,h_481,al_c,lg_1,q_85,enc_avif,quality_auto/image_edited_edited.png",
        },
      ],
    },
    veterinaires: {
      title: "Vétérinaires",
      subtitle:
        "Des professionnels de santé animale qui accompagnent l’association dans les soins, les urgences et le suivi médical.",
      image:
        "https://images.unsplash.com/photo-1628009368231-7bb7cfcb0def?auto=format&fit=crop&w=1600&q=80",
      partners: [
        {
          name: "Clinique NAC & Compagnie",
          image:
            "https://static.wixstatic.com/media/456cbd_bee67cbf91334c0c9463efd5f030f37a~mv2.png/v1/fill/w_461,h_540,al_c,lg_1,q_85,enc_avif,quality_auto/Nacscie-e1716017556880_edited.png",
          city: "Sillingy",
          siteWeb: "https://www.nacetcompagnie.fr",
        },
        {
          name: "Clinique vétérinaire Mont des Princes",
          image:
            "https://static.wixstatic.com/media/456cbd_cc6b8de2310644a1948826c664db399e~mv2.png/v1/fill/w_360,h_421,al_c,lg_1,q_85,enc_avif,quality_auto/image_edited.png",
          siteWeb: "http://www.vetomontdesprinces.com",
          address: "Seyssel",
        },
        {
          name: "Clinique vétérinaire de l'Albanais",
          image:
            "https://static.wixstatic.com/media/456cbd_785f7b4192904861a9267c4fb122f5d4~mv2.png/v1/fill/w_572,h_670,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/image_edited_edited.png",
          address: "Rumilly",
          siteWeb: "https://veterinaire-albanais.com",
        },
        {
          name: "La Yourte Vétérinaire",
          image:
            "https://static.wixstatic.com/media/456cbd_1bef74b510204e44a6a77a5502e8c3d2~mv2.png/v1/fill/w_572,h_670,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/image_edited_edited.png",
          address: "Faverges",
          siteWeb: "http://yourteveterinaire.com",
        },
        {
          name: "Clinique vétérinaire de la Tournette",
          image:
            "https://static.wixstatic.com/media/456cbd_273dfbbc03be429089966858ed7996b8~mv2.png/v1/fill/w_526,h_616,al_c,lg_1,q_85,enc_avif,quality_auto/CVTournette_edited.png",
          address: "Meythet",
          siteWeb:
            "https://cliniquedelatournette.myvetapps.fr/index.php/page/home",
        },
        {
          name: "Dr Senger Edouard",
          image:
            "https://static.wixstatic.com/media/456cbd_f485fb481d5c41678c07e081092e32f5~mv2.webp/v1/fill/w_572,h_670,al_c,lg_1,q_85,enc_avif,quality_auto/Tipaw-Connect-content-10-1618416120967-full-314390.webp",
          address: "Sallanches",
          siteWeb: "https://vetissimo.fr",
        },
        {
          name: "Cabinet vétérinaire Porte des Bauges",
          image:
            "https://static.wixstatic.com/media/456cbd_7d4c88e8b1b64ac7bbc39bd1bdef9aec~mv2.png/v1/fill/w_430,h_504,al_c,q_85,enc_avif,quality_auto/15a85c1950293cd40ccc563e44fb1b4040cf7181.png",
          address: "Cusy",
          siteWeb: "https://share.google/HGjebijFskUoda0qr",
        },
        {
          name: "Clinique vétérinaire VetoLac",
          image:
            "https://static.wixstatic.com/media/456cbd_1d3593d5beb644a1b0d6168d61198039~mv2.png/v1/fill/w_572,h_670,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/vetolac_edited.png",
          address: "Le Bourget-du-Lac",
          siteWeb:
            "https://www.argos-veterinaire.com/nos-cliniques-veterinaires-2/clinique/vetolac-237",
        },
        {
          name: "Clinique vétérinaire VetAfforêts",
          image:
            "https://static.wixstatic.com/media/456cbd_e7850527493346ebbe692893da056944~mv2.png/v1/fill/w_572,h_670,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Fiche-Presentation-Logo-LES-AFFORETS-300.png",
          address: "La Roche-sur-Foron",
          siteWeb: "https://www.vetafforets.fr",
        },
        {
          name: "Centre Hospitalier Vétérinaire Saint-Martin",
          image:
            "https://static.wixstatic.com/media/456cbd_dddd88e09ecd4786b2c289b9ff0237ec~mv2.jpg/v1/fill/w_512,h_600,al_c,lg_1,q_80,enc_avif,quality_auto/637e3b484e0000f059544e1e.jpg",
          address: "Allonzier-la-Caille",
          siteWeb: "https://chvsm.com",
        },
        {
          name: "Clinique vétérinaire de l'Épine",
          image:
            "https://static.wixstatic.com/media/456cbd_f159476464794a2d8ece8a75656521dc~mv2.png/v1/fill/w_252,h_295,al_c,lg_1,q_85,enc_avif,quality_auto/6655a4b32e0000ca1529f555_edited.png",
          address: "Cognin",
          siteWeb:
            "https://www.veterinaire-monveto.com/cliniques/clinique-veterinaire-de-lepine/?utm_source=gmb",
        },
        {
          name: "Clinique vétérinaire du Grand Verger",
          image:
            "https://static.wixstatic.com/media/456cbd_07fb5e1fb2924b2f98d6467e3b5b7682~mv2.png/v1/fill/w_572,h_670,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/62860f7ade614329761147_edited.png",
          address: "Chambéry",
          siteWeb: "https://www.cliniqueveterinairedugrandverger.com",
        },
        {
          name: "Clinique Vétérinaire République",
          image:
            "https://www.monrendezvousveto.fr/media/cache/clinic_thumb/uploads/images/clinic/63/63ecea97a2fbb878363789.png",
          address: "CRAN GEVRIER",
          siteWeb: "https://cliniqueveterinaire74-lefebvre-23.webself.net/accueil",
        },
        {
          name: "Clinique Vétérinaire de la Dent du Chat",
          image : "data:image/png;base64,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",
          address: "Aix-les-bains",
          siteWeb: "https://www.veterinairedentduchat.com"
        },
        {
          name: "Clinique vétérinaire Arvets",
          image: "https://arvets.fr/wp-content/uploads/2024/02/logo-clinique-arvets.webp",
          address: "Cluses",
          siteWeb: "https://arvets.fr"
        }
      ],
    },
    autres: {
      title: "Autres partenaires",
      subtitle:
        "Entreprises, associations, commerces et acteurs locaux qui participent à leur manière à la protection animale.",
      image:
        "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1600&q=80",
      partners: [
        {
          name: "Hardcore Care",
          image:
            "https://static.wixstatic.com/media/456cbd_16973ca070dd4b9686068915ef13ac14~mv2.png/v1/fill/w_400,h_468,al_c,lg_1,q_85,enc_avif,quality_auto/image_edited.png",
        },
        {
          name: "Fondation Brigitte Bardot",
          image:
            "https://static.wixstatic.com/media/456cbd_b562e2876d654d279fd35f2b1624d250~mv2.png/v1/fill/w_572,h_670,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/fondation-brigitte-bardot-logo_edited_pn.png",
        },
        {
          name: "FMR Radio",
          image:
            "https://static.wixstatic.com/media/456cbd_1c7795a8f78349d28b4c0d777927c57c~mv2.png/v1/fill/w_572,h_670,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/image_edited.png",
        },
        {
          name: "Un geste un sourire",
          image:
            "https://static.wixstatic.com/media/456cbd_8e5b223c0891492d9059b4d5ab46ea26~mv2.png/v1/fill/w_572,h_670,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/image_edited.png",
        },
      ],
    },
  };

  const current = data[category];

  const seoByCategory = {
    supermarches: {
      title: "Partenaires supermarchés | Savoinimaux",
      description:
        "Découvrez les supermarchés partenaires de Savoinimaux, engagés aux côtés de l’association à travers des collectes, des relais locaux et des actions solidaires en Savoie et Haute-Savoie.",
    },
    veterinaires: {
      title: "Partenaires vétérinaires | Savoinimaux",
      description:
        "Découvrez les cliniques et cabinets vétérinaires partenaires de Savoinimaux, mobilisés pour les soins, les urgences et le suivi médical des animaux pris en charge.",
    },
    autres: {
      title: "Autres partenaires | Savoinimaux",
      description:
        "Découvrez les autres partenaires de Savoinimaux : associations, entreprises, commerces et acteurs locaux engagés pour la protection animale en Savoie et Haute-Savoie.",
    },
  };

  const seo = seoByCategory[category] || {
    title: "Partenaires | Savoinimaux",
    description:
      "Découvrez les partenaires de Savoinimaux engagés pour la protection animale en Savoie et Haute-Savoie.",
  };

  const canonicalUrl = `https://savoinimaux.com/partenaires/${category}`;

  useEffect(() => {
    if (!current) return;

    cardsRef.current.forEach((card) => {
      if (!card) return;

      gsap.fromTo(
        card,
        { opacity: 0, y: 60 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power3.out",
          scrollTrigger: {
            trigger: card,
            start: "top 85%",
          },
        }
      );
    });

    if (bgRef.current && heroRef.current) {
      gsap.to(bgRef.current, {
        y: 80,
        scrollTrigger: {
          trigger: heroRef.current,
          scrub: true,
        },
      });
    }

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, [current]);

  if (!current) return <div>Not found</div>;

  return (
    <div className="min-h-screen bg-[#fbfbf9] text-[#111111]">
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <link rel="canonical" href={canonicalUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:image" content={current.image} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seo.title} />
        <meta name="twitter:description" content={seo.description} />
        <meta name="twitter:image" content={current.image} />
      </Helmet>

      <main>
        <section ref={heroRef} className="relative -mt-[80px] overflow-hidden">
          <img
            ref={bgRef}
            src={current.image}
            loading="lazy"
            alt={current.title}
            className="absolute inset-0 h-[520px] w-full scale-[1.1] object-cover"
          />

          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-black/10" />

          <div className="relative mx-auto flex min-h-[520px] max-w-7xl flex-col justify-end px-6 pb-10 pt-[120px]">
            <Link
              to="/partenaires"
              className="mb-6 inline-flex items-center gap-2 text-white"
            >
              <ArrowLeft className="h-4 w-4" />
              Retour
            </Link>

            <h1 className="text-5xl font-semibold text-white md:text-6xl">
              {current.title}
            </h1>

            <p className="mt-4 max-w-2xl text-white/80">{current.subtitle}</p>
          </div>
        </section>

        <section className="px-6 py-16">
          <div className="mx-auto max-w-7xl">
            <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
              {current.partners.map((partner, index) => (
                <div
                  key={partner.name}
                  ref={(el) => (cardsRef.current[index] = el)}
                  className="group relative rounded-[1.8rem] border border-black/10 bg-white p-6 shadow-[0_20px_60px_rgba(0,0,0,0.04)] transition duration-300 hover:-translate-y-2 hover:shadow-[0_40px_120px_rgba(220,38,38,0.15)]"
                >
                  <div className="absolute inset-0 rounded-[1.8rem] bg-red-500 opacity-0 blur-2xl transition group-hover:opacity-10" />

                  <div className="relative z-10">
                    {partner.image && (
                      <div className="mb-5 flex h-40 items-center justify-center overflow-hidden rounded-[1.2rem]">
                        <img
                          src={partner.image}
                          alt={partner.name}
                          loading="lazy"
                          className="max-h-full max-w-full object-contain transition duration-300 group-hover:scale-105"
                        />
                      </div>
                    )}

                    <div className="flex items-center justify-between gap-4">
                      <h3 className="text-xl font-semibold leading-tight">
                        {partner.name}
                      </h3>

                      <ArrowRight className="h-4 w-4 text-red-600 transition group-hover:translate-x-1" />
                    </div>

                    {partner.description && (
                      <p className="mt-4 text-sm leading-7 text-black/60">
                        {partner.description}
                      </p>
                    )}

                    {(partner.phone || partner.email || partner.address || partner.city) && (
                      <div className="mt-5 space-y-2 border-t border-black/8 pt-4 text-sm text-black/55">
                        {partner.phone && (
                          <p className="flex items-center gap-2">
                            <Phone className="h-4 w-4 text-red-600" />
                            {partner.phone}
                          </p>
                        )}

                        {partner.email && (
                          <p className="flex items-center gap-2">
                            <Mail className="h-4 w-4 text-red-600" />
                            {partner.email}
                          </p>
                        )}

                        {partner.address && (
                          <p className="flex items-center gap-2">
                            <MapPin className="h-4 w-4 text-red-600" />
                            {partner.address}
                          </p>
                        )}

                        {partner.city && !partner.address && (
                          <p className="flex items-center gap-2">
                            <MapPin className="h-4 w-4 text-red-600" />
                            {partner.city}
                          </p>
                        )}
                      </div>
                    )}

                    {partner.siteWeb && (
                      <a
                        href={partner.siteWeb}
                        target="_blank"
                        rel="noreferrer"
                        className="mt-6 inline-flex rounded-full bg-red-600 px-5 py-2 text-sm text-white transition hover:bg-red-500 active:scale-95"
                      >
                        Site internet
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}